<template>
  <div class="min-h-screen bg-app-bg-light dark:bg-app-bg-dark transition-colors duration-300">
    <!-- Dashboards basados en DashboardTipo del rol -->
    <DashboardAdmin v-if="dashboardTipo === 1" />
    <DashboardRecepcionista v-else-if="dashboardTipo === 2" />
    <DashboardLimpieza v-else-if="dashboardTipo === 3" />
    <DashboardMantenimiento v-else-if="dashboardTipo === 4" />
    <DashboardInventarios v-else-if="dashboardTipo === 5" />
    <DashboardSupervisor v-else-if="dashboardTipo === 6" />
    <DashboardMesero v-else-if="dashboardTipo === 7" />
    <DashboardCajero v-else-if="dashboardTipo === 8" />
    <DashboardPantallas v-else-if="dashboardTipo === 9" />
    <DashboardReportes v-else-if="dashboardTipo === 10" />
    <DashboardContador v-else-if="dashboardTipo === 11" />

    <!-- Dashboard Genérico para roles nuevos sin DashboardTipo específico -->
    <DashboardGenerico v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DashboardAdmin from '@/components/dashboards/DashboardAdmin.vue';
import DashboardRecepcionista from '@/components/dashboards/DashboardRecepcionista.vue';
import DashboardLimpieza from '@/components/dashboards/DashboardLimpieza.vue';
import DashboardMantenimiento from '@/components/dashboards/DashboardMantenimiento.vue';
import DashboardInventarios from '@/components/dashboards/DashboardInventarios.vue';
import DashboardSupervisor from '@/components/dashboards/DashboardSupervisor.vue';
import DashboardMesero from '@/components/dashboards/DashboardMesero.vue';
import DashboardCajero from '@/components/dashboards/DashboardCajero.vue';
import DashboardPantallas from '@/components/dashboards/DashboardPantallas.vue';
import DashboardReportes from '@/components/dashboards/DashboardReportes.vue';
import DashboardContador from '@/components/dashboards/DashboardContador.vue';
import DashboardGenerico from '@/components/dashboards/DashboardGenerico.vue';

export default {
  name: 'DashboardPrincipal',
  components: {
    DashboardAdmin,
    DashboardRecepcionista,
    DashboardLimpieza,
    DashboardMantenimiento,
    DashboardInventarios,
    DashboardSupervisor,
    DashboardMesero,
    DashboardCajero,
    DashboardPantallas,
    DashboardReportes,
    DashboardContador,
    DashboardGenerico
  },
  computed: {
    ...mapState(['user']),
    dashboardTipo() {
      // Si el usuario tiene DashboardTipo definido, usarlo
      if (this.user?.DashboardTipo !== null && this.user?.DashboardTipo !== undefined) {
        return this.user.DashboardTipo;
      }
      // Fallback: usar IdRol para roles antiguos (compatibilidad)
      if (this.user?.IdRol && this.user.IdRol <= 10) {
        return this.user.IdRol;
      }
      // Roles nuevos sin DashboardTipo: mostrar genérico
      return null;
    }
  }
};
</script>
